import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mvpApi } from '../services/api';
import LanguageSwitch from '../components/LanguageSwitch';
import './ReferralListPage.css';

export default function ReferralListPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    mvpApi
      .getMyReferrals()
      .then((res) => {
        if (!cancelled && res.data?.referrals) setReferrals(res.data.referrals);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.detail || 'Could not load list');
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
      return dateStr;
    }
  };

  return (
    <div className="mvp-referrals-page">
      <header className="mvp-referrals-header">
        <button type="button" className="mvp-referrals-back" onClick={() => navigate('/refer')}>
          ← {t('back')}
        </button>
        <h1 className="mvp-referrals-title">{t('referrals.title')}</h1>
        <p className="mvp-referrals-desc">{t('referrals.desc')}</p>
        <LanguageSwitch />
      </header>
      <main className="mvp-referrals-main">
        {loading && <p className="mvp-referrals-loading">{t('loading')}</p>}
        {error && <p className="mvp-referrals-error">{error}</p>}
        {!loading && !error && referrals.length === 0 && (
          <p className="mvp-referrals-empty">{t('referrals.empty')}</p>
        )}
        {!loading && !error && referrals.length > 0 && (
          <ul className="mvp-referrals-list">
            {referrals.map((r) => (
              <li key={r.id || r.email || r.phone} className="mvp-referrals-item">
                <span className="mvp-referrals-item-name">{r.name || r.email || r.phone || '-'}</span>
                {r.created_at && (
                  <span className="mvp-referrals-item-date">{formatDate(r.created_at)}</span>
                )}
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
